import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import AboutPage from './components/About/AboutPage';
import LoginPage from './components/Authentication/LoginPage';
import Logout from './components/Authentication/Logout';
import RegisterPage from './components/Authentication/RegisterPage';
import BlogPage from './components/Blog/BlogPage';
import SingleBlogPage from './components/Blog/SingleBlogPage';
import CartPage from './components/Cart/CartPage';
import CheckoutPage from './components/Checkout/CheckoutPage';
import SimpleLoader from './components/Common/Loading';
import ContactPage from './components/Contact/ContactPage';
import DeleteAccount from './components/DeleteAcount';
import Faqs from './components/Faqs';
import Home from './components/Home/HomePage';
import NotFoundPage from './components/NotFound/NotFoundPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import ReturnPolicy from './components/ReturnPolicy';
import SearchResults from './components/SearchResults';
import CategoryPage from './components/Shop/CategoryPage';
import ShopPage from './components/Shop/ShopPage';
import SingleProductPage from './components/Shop/SingleProductPage';
import Sitemap from './components/Sitemap';
import TermsAndConditions from './components/TermsAndConditions';
import AccountMain from './components/UserAccount/AccountMain';
import MyWishlist from './components/UserAccount/MyWishlist';
import OrderDetails from './components/UserAccount/OrderDetails';
import OrdersHistory from './components/UserAccount/OrdersHistory';
import ProfileSetting from './components/UserAccount/ProfileSetting';
import UserAccount from './components/UserAccount/UserAccount';
import VideosPage from './components/Videos/VideosPage';
import WishlistPage from './components/Wishlish/WishlistPage';
import ProtectedRoute from './ProtectedRoute';
const AllRouting = () => {
  return (
    <Suspense
      fallback={
        <div className="loading-wrapper">
          <SimpleLoader />
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop/" element={<ShopPage />} />
        <Route
          exact
          path="/shop/:subcat_slug/:product_slug/"
          element={<SingleProductPage />}
        />
        <Route path="/category/:slug" element={<CategoryPage />} />
        {/* Route for category with subcategory */}
        <Route path="/category/:slug/:subSlug/" element={<CategoryPage />} />
        <Route path="/blogs/" element={<BlogPage />} />
        <Route path="/blog-detail/:b_slug" element={<SingleBlogPage />} />
        <Route path="/contact/" element={<ContactPage />} />
        <Route path="/videos/" element={<VideosPage />} />
        <Route path="/login/" element={<LoginPage />} />
        <Route path="/register/" element={<RegisterPage />} />
        <Route path="/cart/" element={<CartPage />} />
        <Route path="/wishlist/" element={<WishlistPage />} />
        <Route path="/checkout/" element={<CheckoutPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/order-detail/:orderId/" element={<OrderDetails />} />
          <Route path="/account/" element={<UserAccount />}>
            <Route path="profile/" element={<AccountMain />} />
            <Route path="orders-history/" element={<OrdersHistory />} />
            <Route path="my-wishlist/" element={<MyWishlist />} />
            <Route path="profile-setting/" element={<ProfileSetting />} />
            <Route path="logout/" element={<Logout />} />
          </Route>
        </Route>
        <Route path="/delete-account/" element={<DeleteAccount />} />
        <Route path="/about/" element={<AboutPage />} />
        <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
        <Route path="/return-policy/" element={<ReturnPolicy />} />
        <Route path="/terms-and-conditions/" element={<TermsAndConditions />} />
        <Route path="/faqs/" element={<Faqs />} />
        <Route path="/sitemap/" element={<Sitemap />} />
        <Route path="/search-results/" element={<SearchResults />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};
export default AllRouting;
